import * as Types from '../../graphqlBase.generated';

import { TypedDocumentString } from "~/gql/graphqlBase.generated";
import { baseApiWithGraphql } from '~/services/baseApi';
import type { GraphqlEndpointBuilder } from '~/services/baseApi';
export type CreateProductionMaterialEventMutationVariables = Types.Exact<{
  input: Types.CreateProductionMaterialEventInput;
}>;


export type CreateProductionMaterialEventMutation = { __typename?: 'Mutation', createProductionMaterialEvent: { __typename?: 'ProductionMaterialEventPayload', event?: { __typename?: 'ProductionMaterialEventStateData', tenantId: string, productionMaterialEventId: string, name: string, updatedAt: Types.TDateISO, updatedBy: string, createdBy: string, createdAt: Types.TDateISO, status: Types.ProductionMaterialEventStatus, details: Array<{ __typename?: 'ProductionMaterialEventDetailData', description: string, materialItemId: string, multiple: number, productionMaterialEventDetailId: string, triggerId: string }> } | null, errors?: Array<{ __typename?: 'ValidationError', code?: string | null, message: string }> | null } };

export type UpdateProductionMaterialEventMutationVariables = Types.Exact<{
  input: Types.UpdateProductionMaterialEventInput;
}>;


export type UpdateProductionMaterialEventMutation = { __typename?: 'Mutation', updateProductionMaterialEvent: { __typename?: 'ProductionMaterialEventPayload', event?: { __typename?: 'ProductionMaterialEventStateData', tenantId: string, productionMaterialEventId: string, name: string, updatedAt: Types.TDateISO, updatedBy: string, createdBy: string, createdAt: Types.TDateISO, status: Types.ProductionMaterialEventStatus, details: Array<{ __typename?: 'ProductionMaterialEventDetailData', description: string, materialItemId: string, multiple: number, productionMaterialEventDetailId: string, triggerId: string }> } | null, errors?: Array<{ __typename?: 'ValidationError', code?: string | null, message: string }> | null } };

export type ActivateProductionMaterialEventMutationVariables = Types.Exact<{
  input: Types.ActivateProductionMaterialEventInput;
}>;


export type ActivateProductionMaterialEventMutation = { __typename?: 'Mutation', activateProductionMaterialEvent: { __typename?: 'ProductionMaterialEventPayload', event?: { __typename?: 'ProductionMaterialEventStateData', tenantId: string, productionMaterialEventId: string, name: string, updatedAt: Types.TDateISO, updatedBy: string, createdBy: string, createdAt: Types.TDateISO, status: Types.ProductionMaterialEventStatus, details: Array<{ __typename?: 'ProductionMaterialEventDetailData', description: string, materialItemId: string, multiple: number, productionMaterialEventDetailId: string, triggerId: string }> } | null, errors?: Array<{ __typename?: 'ValidationError', code?: string | null, message: string }> | null } };

export type InactivateProductionMaterialEventMutationVariables = Types.Exact<{
  input: Types.InactivateProductionMaterialEventInput;
}>;


export type InactivateProductionMaterialEventMutation = { __typename?: 'Mutation', inactivateProductionMaterialEvent: { __typename?: 'ProductionMaterialEventPayload', event?: { __typename?: 'ProductionMaterialEventStateData', tenantId: string, productionMaterialEventId: string, name: string, updatedAt: Types.TDateISO, updatedBy: string, createdBy: string, createdAt: Types.TDateISO, status: Types.ProductionMaterialEventStatus, details: Array<{ __typename?: 'ProductionMaterialEventDetailData', description: string, materialItemId: string, multiple: number, productionMaterialEventDetailId: string, triggerId: string }> } | null, errors?: Array<{ __typename?: 'ValidationError', code?: string | null, message: string }> | null } };

export type DeleteProductionMaterialEventMutationVariables = Types.Exact<{
  input: Types.DeleteProductionMaterialEventInput;
}>;


export type DeleteProductionMaterialEventMutation = { __typename?: 'Mutation', deleteProductionMaterialEvent: { __typename?: 'ProductionMaterialEventPayload', event?: { __typename?: 'ProductionMaterialEventStateData', tenantId: string, productionMaterialEventId: string, name: string, updatedAt: Types.TDateISO, updatedBy: string, createdBy: string, createdAt: Types.TDateISO, status: Types.ProductionMaterialEventStatus, details: Array<{ __typename?: 'ProductionMaterialEventDetailData', description: string, materialItemId: string, multiple: number, productionMaterialEventDetailId: string, triggerId: string }> } | null, errors?: Array<{ __typename?: 'ValidationError', code?: string | null, message: string }> | null } };

export type AddProductionMaterialEventDetailsMutationVariables = Types.Exact<{
  input: Types.AddProductionMaterialEventDetailsInput;
}>;


export type AddProductionMaterialEventDetailsMutation = { __typename?: 'Mutation', addProductionMaterialEventDetails: { __typename?: 'ProductionMaterialEventPayload', event?: { __typename?: 'ProductionMaterialEventStateData', tenantId: string, productionMaterialEventId: string, name: string, updatedAt: Types.TDateISO, updatedBy: string, createdBy: string, createdAt: Types.TDateISO, status: Types.ProductionMaterialEventStatus, details: Array<{ __typename?: 'ProductionMaterialEventDetailData', description: string, materialItemId: string, multiple: number, productionMaterialEventDetailId: string, triggerId: string }> } | null, errors?: Array<{ __typename?: 'ValidationError', code?: string | null, message: string }> | null } };

export type UpdateProductionMaterialEventDetailMutationVariables = Types.Exact<{
  input: Types.UpdateProductionMaterialEventDetailInput;
}>;


export type UpdateProductionMaterialEventDetailMutation = { __typename?: 'Mutation', updateProductionMaterialEventDetail: { __typename?: 'ProductionMaterialEventPayload', event?: { __typename?: 'ProductionMaterialEventStateData', tenantId: string, productionMaterialEventId: string, name: string, updatedAt: Types.TDateISO, updatedBy: string, createdBy: string, createdAt: Types.TDateISO, status: Types.ProductionMaterialEventStatus, details: Array<{ __typename?: 'ProductionMaterialEventDetailData', description: string, materialItemId: string, multiple: number, productionMaterialEventDetailId: string, triggerId: string }> } | null, errors?: Array<{ __typename?: 'ValidationError', code?: string | null, message: string }> | null } };

export type RemoveProductionMaterialEventDetailMutationVariables = Types.Exact<{
  input: Types.RemoveProductionMaterialEventDetailInput;
}>;


export type RemoveProductionMaterialEventDetailMutation = { __typename?: 'Mutation', removeProductionMaterialEventDetail: { __typename?: 'ProductionMaterialEventPayload', event?: { __typename?: 'ProductionMaterialEventStateData', tenantId: string, productionMaterialEventId: string, name: string, updatedAt: Types.TDateISO, updatedBy: string, createdBy: string, createdAt: Types.TDateISO, status: Types.ProductionMaterialEventStatus, details: Array<{ __typename?: 'ProductionMaterialEventDetailData', description: string, materialItemId: string, multiple: number, productionMaterialEventDetailId: string, triggerId: string }> } | null, errors?: Array<{ __typename?: 'ValidationError', code?: string | null, message: string }> | null } };

export type CreateProductionTaskEventMutationVariables = Types.Exact<{
  input: Types.CreateProductionTaskEventInput;
}>;


export type CreateProductionTaskEventMutation = { __typename?: 'Mutation', createProductionTaskEvent: { __typename?: 'ProductionTaskEventPayload', event?: { __typename?: 'ProductionTaskEventStateData', tenantId: string, productionTaskEventId: string, name: string, status: Types.ProductionTaskEventStatus, unitsPerHour?: number | null, laborTypeTagId?: string | null, costPerEvent?: number | null, createdBy: string, createdAt: Types.TDateISO, updatedBy: string, updatedAt: Types.TDateISO, details: Array<{ __typename?: 'ProductionTaskEventDetailData', description: string, taskEventTypeId: string, taskEventTypeName: string, materialItemId?: string | null, multiple: number, productionTaskEventDetailId: string, sequence: number, triggerId: string, unitsPerHour?: number | null, taskEventType?: { __typename?: 'TaskEventTypeDocument', reducesSellableStock: boolean } | null }> } | null, errors?: Array<{ __typename?: 'ValidationError', code?: string | null, message: string }> | null } };

export type UpdateProductionTaskEventMutationVariables = Types.Exact<{
  input: Types.UpdateProductionTaskEventInput;
}>;


export type UpdateProductionTaskEventMutation = { __typename?: 'Mutation', updateProductionTaskEvent: { __typename?: 'ProductionTaskEventPayload', event?: { __typename?: 'ProductionTaskEventStateData', tenantId: string, productionTaskEventId: string, name: string, status: Types.ProductionTaskEventStatus, unitsPerHour?: number | null, laborTypeTagId?: string | null, costPerEvent?: number | null, createdBy: string, createdAt: Types.TDateISO, updatedBy: string, updatedAt: Types.TDateISO, details: Array<{ __typename?: 'ProductionTaskEventDetailData', description: string, taskEventTypeId: string, taskEventTypeName: string, materialItemId?: string | null, multiple: number, productionTaskEventDetailId: string, sequence: number, triggerId: string, unitsPerHour?: number | null, taskEventType?: { __typename?: 'TaskEventTypeDocument', reducesSellableStock: boolean } | null }> } | null, errors?: Array<{ __typename?: 'ValidationError', code?: string | null, message: string }> | null } };

export type ActivateProductionTaskEventMutationVariables = Types.Exact<{
  input: Types.ActivateProductionTaskEventInput;
}>;


export type ActivateProductionTaskEventMutation = { __typename?: 'Mutation', activateProductionTaskEvent: { __typename?: 'ProductionTaskEventPayload', event?: { __typename?: 'ProductionTaskEventStateData', tenantId: string, productionTaskEventId: string, name: string, status: Types.ProductionTaskEventStatus, unitsPerHour?: number | null, laborTypeTagId?: string | null, costPerEvent?: number | null, createdBy: string, createdAt: Types.TDateISO, updatedBy: string, updatedAt: Types.TDateISO, details: Array<{ __typename?: 'ProductionTaskEventDetailData', description: string, taskEventTypeId: string, taskEventTypeName: string, materialItemId?: string | null, multiple: number, productionTaskEventDetailId: string, sequence: number, triggerId: string, unitsPerHour?: number | null, taskEventType?: { __typename?: 'TaskEventTypeDocument', reducesSellableStock: boolean } | null }> } | null, errors?: Array<{ __typename?: 'ValidationError', code?: string | null, message: string }> | null } };

export type InactivateProductionTaskEventMutationVariables = Types.Exact<{
  input: Types.InactivateProductionTaskEventInput;
}>;


export type InactivateProductionTaskEventMutation = { __typename?: 'Mutation', inactivateProductionTaskEvent: { __typename?: 'ProductionTaskEventPayload', event?: { __typename?: 'ProductionTaskEventStateData', tenantId: string, productionTaskEventId: string, name: string, status: Types.ProductionTaskEventStatus, unitsPerHour?: number | null, laborTypeTagId?: string | null, costPerEvent?: number | null, createdBy: string, createdAt: Types.TDateISO, updatedBy: string, updatedAt: Types.TDateISO, details: Array<{ __typename?: 'ProductionTaskEventDetailData', description: string, taskEventTypeId: string, taskEventTypeName: string, materialItemId?: string | null, multiple: number, productionTaskEventDetailId: string, sequence: number, triggerId: string, unitsPerHour?: number | null, taskEventType?: { __typename?: 'TaskEventTypeDocument', reducesSellableStock: boolean } | null }> } | null, errors?: Array<{ __typename?: 'ValidationError', code?: string | null, message: string }> | null } };

export type DeleteProductionTaskEventMutationVariables = Types.Exact<{
  input: Types.DeleteProductionTaskEventInput;
}>;


export type DeleteProductionTaskEventMutation = { __typename?: 'Mutation', deleteProductionTaskEvent: { __typename?: 'ProductionTaskEventPayload', event?: { __typename?: 'ProductionTaskEventStateData', tenantId: string, productionTaskEventId: string, name: string, status: Types.ProductionTaskEventStatus, unitsPerHour?: number | null, laborTypeTagId?: string | null, costPerEvent?: number | null, createdBy: string, createdAt: Types.TDateISO, updatedBy: string, updatedAt: Types.TDateISO, details: Array<{ __typename?: 'ProductionTaskEventDetailData', description: string, taskEventTypeId: string, taskEventTypeName: string, materialItemId?: string | null, multiple: number, productionTaskEventDetailId: string, sequence: number, triggerId: string, unitsPerHour?: number | null, taskEventType?: { __typename?: 'TaskEventTypeDocument', reducesSellableStock: boolean } | null }> } | null, errors?: Array<{ __typename?: 'ValidationError', code?: string | null, message: string }> | null } };

export type AddProductionTaskEventDetailsMutationVariables = Types.Exact<{
  input: Types.AddProductionTaskEventDetailsInput;
}>;


export type AddProductionTaskEventDetailsMutation = { __typename?: 'Mutation', addProductionTaskEventDetails: { __typename?: 'ProductionTaskEventPayload', event?: { __typename?: 'ProductionTaskEventStateData', tenantId: string, productionTaskEventId: string, name: string, status: Types.ProductionTaskEventStatus, unitsPerHour?: number | null, laborTypeTagId?: string | null, costPerEvent?: number | null, createdBy: string, createdAt: Types.TDateISO, updatedBy: string, updatedAt: Types.TDateISO, details: Array<{ __typename?: 'ProductionTaskEventDetailData', description: string, taskEventTypeId: string, taskEventTypeName: string, materialItemId?: string | null, multiple: number, productionTaskEventDetailId: string, sequence: number, triggerId: string, unitsPerHour?: number | null, taskEventType?: { __typename?: 'TaskEventTypeDocument', reducesSellableStock: boolean } | null }> } | null, errors?: Array<{ __typename?: 'ValidationError', code?: string | null, message: string }> | null } };

export type UpdateProductionTaskEventDetailMutationVariables = Types.Exact<{
  input: Types.UpdateProductionTaskEventDetailInput;
}>;


export type UpdateProductionTaskEventDetailMutation = { __typename?: 'Mutation', updateProductionTaskEventDetail: { __typename?: 'ProductionTaskEventPayload', event?: { __typename?: 'ProductionTaskEventStateData', tenantId: string, productionTaskEventId: string, name: string, status: Types.ProductionTaskEventStatus, unitsPerHour?: number | null, laborTypeTagId?: string | null, costPerEvent?: number | null, createdBy: string, createdAt: Types.TDateISO, updatedBy: string, updatedAt: Types.TDateISO, details: Array<{ __typename?: 'ProductionTaskEventDetailData', description: string, taskEventTypeId: string, taskEventTypeName: string, materialItemId?: string | null, multiple: number, productionTaskEventDetailId: string, sequence: number, triggerId: string, unitsPerHour?: number | null, taskEventType?: { __typename?: 'TaskEventTypeDocument', reducesSellableStock: boolean } | null }> } | null, errors?: Array<{ __typename?: 'ValidationError', code?: string | null, message: string }> | null } };

export type RemoveProductionTaskEventDetailMutationVariables = Types.Exact<{
  input: Types.RemoveProductionTaskEventDetailInput;
}>;


export type RemoveProductionTaskEventDetailMutation = { __typename?: 'Mutation', removeProductionTaskEventDetail: { __typename?: 'ProductionTaskEventPayload', event?: { __typename?: 'ProductionTaskEventStateData', tenantId: string, productionTaskEventId: string, name: string, status: Types.ProductionTaskEventStatus, unitsPerHour?: number | null, laborTypeTagId?: string | null, costPerEvent?: number | null, createdBy: string, createdAt: Types.TDateISO, updatedBy: string, updatedAt: Types.TDateISO, details: Array<{ __typename?: 'ProductionTaskEventDetailData', description: string, taskEventTypeId: string, taskEventTypeName: string, materialItemId?: string | null, multiple: number, productionTaskEventDetailId: string, sequence: number, triggerId: string, unitsPerHour?: number | null, taskEventType?: { __typename?: 'TaskEventTypeDocument', reducesSellableStock: boolean } | null }> } | null, errors?: Array<{ __typename?: 'ValidationError', code?: string | null, message: string }> | null } };

export type SetTaskEventThroughputMutationVariables = Types.Exact<{
  input: Types.SetTaskEventThroughputInput;
}>;


export type SetTaskEventThroughputMutation = { __typename?: 'Mutation', setTaskEventThroughput: { __typename?: 'ProductionTaskEventPayload', event?: { __typename?: 'ProductionTaskEventStateData', tenantId: string, productionTaskEventId: string, name: string, status: Types.ProductionTaskEventStatus, unitsPerHour?: number | null, laborTypeTagId?: string | null, costPerEvent?: number | null, createdBy: string, createdAt: Types.TDateISO, updatedBy: string, updatedAt: Types.TDateISO, details: Array<{ __typename?: 'ProductionTaskEventDetailData', description: string, taskEventTypeId: string, taskEventTypeName: string, materialItemId?: string | null, multiple: number, productionTaskEventDetailId: string, sequence: number, triggerId: string, unitsPerHour?: number | null, taskEventType?: { __typename?: 'TaskEventTypeDocument', reducesSellableStock: boolean } | null }> } | null, errors?: Array<{ __typename?: 'ValidationError', code?: string | null, message: string }> | null } };

export type SetTaskEventLaborTypeTagMutationVariables = Types.Exact<{
  input: Types.SetTaskEventLaborTypeTagInput;
}>;


export type SetTaskEventLaborTypeTagMutation = { __typename?: 'Mutation', setTaskEventLaborTypeTag: { __typename?: 'ProductionTaskEventPayload', event?: { __typename?: 'ProductionTaskEventStateData', tenantId: string, productionTaskEventId: string, name: string, status: Types.ProductionTaskEventStatus, unitsPerHour?: number | null, laborTypeTagId?: string | null, costPerEvent?: number | null, createdBy: string, createdAt: Types.TDateISO, updatedBy: string, updatedAt: Types.TDateISO, details: Array<{ __typename?: 'ProductionTaskEventDetailData', description: string, taskEventTypeId: string, taskEventTypeName: string, materialItemId?: string | null, multiple: number, productionTaskEventDetailId: string, sequence: number, triggerId: string, unitsPerHour?: number | null, taskEventType?: { __typename?: 'TaskEventTypeDocument', reducesSellableStock: boolean } | null }> } | null, errors?: Array<{ __typename?: 'ValidationError', code?: string | null, message: string }> | null } };

export type CreateProductionSpaceEventMutationVariables = Types.Exact<{
  input: Types.CreateProductionSpaceEventInput;
}>;


export type CreateProductionSpaceEventMutation = { __typename?: 'Mutation', createProductionSpaceEvent: { __typename?: 'ProductionSpaceEventPayload', event?: { __typename?: 'ProductionSpaceEventStateData', createdAt: Types.TDateISO, createdBy: string, name: string, productionSpaceEventId: string, status: Types.ProductionSpaceEventStatus, tenantId: string, updatedAt: Types.TDateISO, updatedBy: string, details: Array<{ __typename?: 'ProductionSpaceEventDetailData', description: string, duration: number, productionSpaceCategoryId: string, productionSpaceEventDetailId: string, productionSpaceTypeId: string, triggerId: string }> } | null, errors?: Array<{ __typename?: 'ValidationError', code?: string | null, message: string }> | null } };

export type UpdateProductionSpaceEventMutationVariables = Types.Exact<{
  input: Types.UpdateProductionSpaceEventInput;
}>;


export type UpdateProductionSpaceEventMutation = { __typename?: 'Mutation', updateProductionSpaceEvent: { __typename?: 'ProductionSpaceEventPayload', event?: { __typename?: 'ProductionSpaceEventStateData', createdAt: Types.TDateISO, createdBy: string, name: string, productionSpaceEventId: string, status: Types.ProductionSpaceEventStatus, tenantId: string, updatedAt: Types.TDateISO, updatedBy: string, details: Array<{ __typename?: 'ProductionSpaceEventDetailData', description: string, duration: number, productionSpaceCategoryId: string, productionSpaceEventDetailId: string, productionSpaceTypeId: string, triggerId: string }> } | null, errors?: Array<{ __typename?: 'ValidationError', code?: string | null, message: string }> | null } };

export type ActivateProductionSpaceEventMutationVariables = Types.Exact<{
  input: Types.ActivateProductionSpaceEventInput;
}>;


export type ActivateProductionSpaceEventMutation = { __typename?: 'Mutation', activateProductionSpaceEvent: { __typename?: 'ProductionSpaceEventPayload', event?: { __typename?: 'ProductionSpaceEventStateData', createdAt: Types.TDateISO, createdBy: string, name: string, productionSpaceEventId: string, status: Types.ProductionSpaceEventStatus, tenantId: string, updatedAt: Types.TDateISO, updatedBy: string, details: Array<{ __typename?: 'ProductionSpaceEventDetailData', description: string, duration: number, productionSpaceCategoryId: string, productionSpaceEventDetailId: string, productionSpaceTypeId: string, triggerId: string }> } | null, errors?: Array<{ __typename?: 'ValidationError', code?: string | null, message: string }> | null } };

export type InactivateProductionSpaceEventMutationVariables = Types.Exact<{
  input: Types.InactivateProductionSpaceEventInput;
}>;


export type InactivateProductionSpaceEventMutation = { __typename?: 'Mutation', inactivateProductionSpaceEvent: { __typename?: 'ProductionSpaceEventPayload', event?: { __typename?: 'ProductionSpaceEventStateData', createdAt: Types.TDateISO, createdBy: string, name: string, productionSpaceEventId: string, status: Types.ProductionSpaceEventStatus, tenantId: string, updatedAt: Types.TDateISO, updatedBy: string, details: Array<{ __typename?: 'ProductionSpaceEventDetailData', description: string, duration: number, productionSpaceCategoryId: string, productionSpaceEventDetailId: string, productionSpaceTypeId: string, triggerId: string }> } | null, errors?: Array<{ __typename?: 'ValidationError', code?: string | null, message: string }> | null } };

export type DeleteProductionSpaceEventMutationVariables = Types.Exact<{
  input: Types.DeleteProductionSpaceEventInput;
}>;


export type DeleteProductionSpaceEventMutation = { __typename?: 'Mutation', deleteProductionSpaceEvent: { __typename?: 'ProductionSpaceEventPayload', event?: { __typename?: 'ProductionSpaceEventStateData', createdAt: Types.TDateISO, createdBy: string, name: string, productionSpaceEventId: string, status: Types.ProductionSpaceEventStatus, tenantId: string, updatedAt: Types.TDateISO, updatedBy: string, details: Array<{ __typename?: 'ProductionSpaceEventDetailData', description: string, duration: number, productionSpaceCategoryId: string, productionSpaceEventDetailId: string, productionSpaceTypeId: string, triggerId: string }> } | null, errors?: Array<{ __typename?: 'ValidationError', code?: string | null, message: string }> | null } };

export type AddProductionSpaceEventDetailsMutationVariables = Types.Exact<{
  input: Types.AddProductionSpaceEventDetailsInput;
}>;


export type AddProductionSpaceEventDetailsMutation = { __typename?: 'Mutation', addProductionSpaceEventDetails: { __typename?: 'ProductionSpaceEventPayload', event?: { __typename?: 'ProductionSpaceEventStateData', createdAt: Types.TDateISO, createdBy: string, name: string, productionSpaceEventId: string, status: Types.ProductionSpaceEventStatus, tenantId: string, updatedAt: Types.TDateISO, updatedBy: string, details: Array<{ __typename?: 'ProductionSpaceEventDetailData', description: string, duration: number, productionSpaceCategoryId: string, productionSpaceEventDetailId: string, productionSpaceTypeId: string, triggerId: string }> } | null, errors?: Array<{ __typename?: 'ValidationError', code?: string | null, message: string }> | null } };

export type UpdateProductionSpaceEventDetailMutationVariables = Types.Exact<{
  input: Types.UpdateProductionSpaceEventDetailInput;
}>;


export type UpdateProductionSpaceEventDetailMutation = { __typename?: 'Mutation', updateProductionSpaceEventDetail: { __typename?: 'ProductionSpaceEventPayload', event?: { __typename?: 'ProductionSpaceEventStateData', createdAt: Types.TDateISO, createdBy: string, name: string, productionSpaceEventId: string, status: Types.ProductionSpaceEventStatus, tenantId: string, updatedAt: Types.TDateISO, updatedBy: string, details: Array<{ __typename?: 'ProductionSpaceEventDetailData', description: string, duration: number, productionSpaceCategoryId: string, productionSpaceEventDetailId: string, productionSpaceTypeId: string, triggerId: string }> } | null, errors?: Array<{ __typename?: 'ValidationError', code?: string | null, message: string }> | null } };

export type RemoveProductionSpaceEventDetailMutationVariables = Types.Exact<{
  input: Types.RemoveProductionSpaceEventDetailInput;
}>;


export type RemoveProductionSpaceEventDetailMutation = { __typename?: 'Mutation', removeProductionSpaceEventDetail: { __typename?: 'ProductionSpaceEventPayload', event?: { __typename?: 'ProductionSpaceEventStateData', createdAt: Types.TDateISO, createdBy: string, name: string, productionSpaceEventId: string, status: Types.ProductionSpaceEventStatus, tenantId: string, updatedAt: Types.TDateISO, updatedBy: string, details: Array<{ __typename?: 'ProductionSpaceEventDetailData', description: string, duration: number, productionSpaceCategoryId: string, productionSpaceEventDetailId: string, productionSpaceTypeId: string, triggerId: string }> } | null, errors?: Array<{ __typename?: 'ValidationError', code?: string | null, message: string }> | null } };

export type ClearTaskEventThroughputMutationVariables = Types.Exact<{
  input: Types.ClearTaskEventThroughputInput;
}>;


export type ClearTaskEventThroughputMutation = { __typename?: 'Mutation', clearTaskEventThroughput: { __typename?: 'ProductionTaskEventPayload', event?: { __typename?: 'ProductionTaskEventStateData', tenantId: string, productionTaskEventId: string, name: string, status: Types.ProductionTaskEventStatus, unitsPerHour?: number | null, laborTypeTagId?: string | null, costPerEvent?: number | null, createdBy: string, createdAt: Types.TDateISO, updatedBy: string, updatedAt: Types.TDateISO, details: Array<{ __typename?: 'ProductionTaskEventDetailData', description: string, taskEventTypeId: string, taskEventTypeName: string, materialItemId?: string | null, multiple: number, productionTaskEventDetailId: string, sequence: number, triggerId: string, unitsPerHour?: number | null, taskEventType?: { __typename?: 'TaskEventTypeDocument', reducesSellableStock: boolean } | null }> } | null, errors?: Array<{ __typename?: 'ValidationError', code?: string | null, message: string }> | null } };

export type ClearTaskEventLaborTypeTagMutationVariables = Types.Exact<{
  input: Types.ClearTaskEventLaborTypeTagInput;
}>;


export type ClearTaskEventLaborTypeTagMutation = { __typename?: 'Mutation', clearTaskEventLaborTypeTag: { __typename?: 'ProductionTaskEventPayload', event?: { __typename?: 'ProductionTaskEventStateData', tenantId: string, productionTaskEventId: string, name: string, status: Types.ProductionTaskEventStatus, unitsPerHour?: number | null, laborTypeTagId?: string | null, costPerEvent?: number | null, createdBy: string, createdAt: Types.TDateISO, updatedBy: string, updatedAt: Types.TDateISO, details: Array<{ __typename?: 'ProductionTaskEventDetailData', description: string, taskEventTypeId: string, taskEventTypeName: string, materialItemId?: string | null, multiple: number, productionTaskEventDetailId: string, sequence: number, triggerId: string, unitsPerHour?: number | null, taskEventType?: { __typename?: 'TaskEventTypeDocument', reducesSellableStock: boolean } | null }> } | null, errors?: Array<{ __typename?: 'ValidationError', code?: string | null, message: string }> | null } };

export type SetTaskEventDetailThroughputMutationVariables = Types.Exact<{
  input: Types.SetTaskEventDetailThroughputInput;
}>;


export type SetTaskEventDetailThroughputMutation = { __typename?: 'Mutation', setTaskEventDetailThroughput: { __typename?: 'ProductionTaskEventPayload', event?: { __typename?: 'ProductionTaskEventStateData', tenantId: string, productionTaskEventId: string, name: string, status: Types.ProductionTaskEventStatus, unitsPerHour?: number | null, laborTypeTagId?: string | null, costPerEvent?: number | null, createdBy: string, createdAt: Types.TDateISO, updatedBy: string, updatedAt: Types.TDateISO, details: Array<{ __typename?: 'ProductionTaskEventDetailData', description: string, taskEventTypeId: string, taskEventTypeName: string, materialItemId?: string | null, multiple: number, productionTaskEventDetailId: string, sequence: number, triggerId: string, unitsPerHour?: number | null, taskEventType?: { __typename?: 'TaskEventTypeDocument', reducesSellableStock: boolean } | null }> } | null, errors?: Array<{ __typename?: 'ValidationError', code?: string | null, message: string }> | null } };

export type SetTaskEventDirectCostMutationVariables = Types.Exact<{
  input: Types.SetTaskEventDirectCostInput;
}>;


export type SetTaskEventDirectCostMutation = { __typename?: 'Mutation', setTaskEventDirectCost: { __typename?: 'ProductionTaskEventPayload', event?: { __typename?: 'ProductionTaskEventStateData', tenantId: string, productionTaskEventId: string, name: string, status: Types.ProductionTaskEventStatus, unitsPerHour?: number | null, laborTypeTagId?: string | null, costPerEvent?: number | null, createdBy: string, createdAt: Types.TDateISO, updatedBy: string, updatedAt: Types.TDateISO, details: Array<{ __typename?: 'ProductionTaskEventDetailData', description: string, taskEventTypeId: string, taskEventTypeName: string, materialItemId?: string | null, multiple: number, productionTaskEventDetailId: string, sequence: number, triggerId: string, unitsPerHour?: number | null, taskEventType?: { __typename?: 'TaskEventTypeDocument', reducesSellableStock: boolean } | null }> } | null, errors?: Array<{ __typename?: 'ValidationError', code?: string | null, message: string }> | null } };

export type ClearTaskEventDirectCostMutationVariables = Types.Exact<{
  input: Types.ClearTaskEventDirectCostInput;
}>;


export type ClearTaskEventDirectCostMutation = { __typename?: 'Mutation', clearTaskEventDirectCost: { __typename?: 'ProductionTaskEventPayload', event?: { __typename?: 'ProductionTaskEventStateData', tenantId: string, productionTaskEventId: string, name: string, status: Types.ProductionTaskEventStatus, unitsPerHour?: number | null, laborTypeTagId?: string | null, costPerEvent?: number | null, createdBy: string, createdAt: Types.TDateISO, updatedBy: string, updatedAt: Types.TDateISO, details: Array<{ __typename?: 'ProductionTaskEventDetailData', description: string, taskEventTypeId: string, taskEventTypeName: string, materialItemId?: string | null, multiple: number, productionTaskEventDetailId: string, sequence: number, triggerId: string, unitsPerHour?: number | null, taskEventType?: { __typename?: 'TaskEventTypeDocument', reducesSellableStock: boolean } | null }> } | null, errors?: Array<{ __typename?: 'ValidationError', code?: string | null, message: string }> | null } };


export const CreateProductionMaterialEventDocument = new TypedDocumentString(`
    mutation CreateProductionMaterialEvent($input: CreateProductionMaterialEventInput!) {
  createProductionMaterialEvent(input: $input) {
    event {
      ...ProductionMaterialEventDetails
    }
    errors {
      code
      message
    }
  }
}
    fragment ProductionMaterialEventDetails on ProductionMaterialEventStateData {
  tenantId
  productionMaterialEventId
  name
  details {
    ...ProductionMaterialEventDetailFragment
  }
  updatedAt
  updatedBy
  createdBy
  createdAt
  status
}
fragment ProductionMaterialEventDetailFragment on ProductionMaterialEventDetailData {
  description
  materialItemId
  multiple
  productionMaterialEventDetailId
  triggerId
}`);
export const UpdateProductionMaterialEventDocument = new TypedDocumentString(`
    mutation UpdateProductionMaterialEvent($input: UpdateProductionMaterialEventInput!) {
  updateProductionMaterialEvent(input: $input) {
    event {
      ...ProductionMaterialEventDetails
    }
    errors {
      code
      message
    }
  }
}
    fragment ProductionMaterialEventDetails on ProductionMaterialEventStateData {
  tenantId
  productionMaterialEventId
  name
  details {
    ...ProductionMaterialEventDetailFragment
  }
  updatedAt
  updatedBy
  createdBy
  createdAt
  status
}
fragment ProductionMaterialEventDetailFragment on ProductionMaterialEventDetailData {
  description
  materialItemId
  multiple
  productionMaterialEventDetailId
  triggerId
}`);
export const ActivateProductionMaterialEventDocument = new TypedDocumentString(`
    mutation ActivateProductionMaterialEvent($input: ActivateProductionMaterialEventInput!) {
  activateProductionMaterialEvent(input: $input) {
    event {
      ...ProductionMaterialEventDetails
    }
    errors {
      code
      message
    }
  }
}
    fragment ProductionMaterialEventDetails on ProductionMaterialEventStateData {
  tenantId
  productionMaterialEventId
  name
  details {
    ...ProductionMaterialEventDetailFragment
  }
  updatedAt
  updatedBy
  createdBy
  createdAt
  status
}
fragment ProductionMaterialEventDetailFragment on ProductionMaterialEventDetailData {
  description
  materialItemId
  multiple
  productionMaterialEventDetailId
  triggerId
}`);
export const InactivateProductionMaterialEventDocument = new TypedDocumentString(`
    mutation InactivateProductionMaterialEvent($input: InactivateProductionMaterialEventInput!) {
  inactivateProductionMaterialEvent(input: $input) {
    event {
      ...ProductionMaterialEventDetails
    }
    errors {
      code
      message
    }
  }
}
    fragment ProductionMaterialEventDetails on ProductionMaterialEventStateData {
  tenantId
  productionMaterialEventId
  name
  details {
    ...ProductionMaterialEventDetailFragment
  }
  updatedAt
  updatedBy
  createdBy
  createdAt
  status
}
fragment ProductionMaterialEventDetailFragment on ProductionMaterialEventDetailData {
  description
  materialItemId
  multiple
  productionMaterialEventDetailId
  triggerId
}`);
export const DeleteProductionMaterialEventDocument = new TypedDocumentString(`
    mutation DeleteProductionMaterialEvent($input: DeleteProductionMaterialEventInput!) {
  deleteProductionMaterialEvent(input: $input) {
    event {
      ...ProductionMaterialEventDetails
    }
    errors {
      code
      message
    }
  }
}
    fragment ProductionMaterialEventDetails on ProductionMaterialEventStateData {
  tenantId
  productionMaterialEventId
  name
  details {
    ...ProductionMaterialEventDetailFragment
  }
  updatedAt
  updatedBy
  createdBy
  createdAt
  status
}
fragment ProductionMaterialEventDetailFragment on ProductionMaterialEventDetailData {
  description
  materialItemId
  multiple
  productionMaterialEventDetailId
  triggerId
}`);
export const AddProductionMaterialEventDetailsDocument = new TypedDocumentString(`
    mutation AddProductionMaterialEventDetails($input: AddProductionMaterialEventDetailsInput!) {
  addProductionMaterialEventDetails(input: $input) {
    event {
      ...ProductionMaterialEventDetails
    }
    errors {
      code
      message
    }
  }
}
    fragment ProductionMaterialEventDetails on ProductionMaterialEventStateData {
  tenantId
  productionMaterialEventId
  name
  details {
    ...ProductionMaterialEventDetailFragment
  }
  updatedAt
  updatedBy
  createdBy
  createdAt
  status
}
fragment ProductionMaterialEventDetailFragment on ProductionMaterialEventDetailData {
  description
  materialItemId
  multiple
  productionMaterialEventDetailId
  triggerId
}`);
export const UpdateProductionMaterialEventDetailDocument = new TypedDocumentString(`
    mutation UpdateProductionMaterialEventDetail($input: UpdateProductionMaterialEventDetailInput!) {
  updateProductionMaterialEventDetail(input: $input) {
    event {
      ...ProductionMaterialEventDetails
    }
    errors {
      code
      message
    }
  }
}
    fragment ProductionMaterialEventDetails on ProductionMaterialEventStateData {
  tenantId
  productionMaterialEventId
  name
  details {
    ...ProductionMaterialEventDetailFragment
  }
  updatedAt
  updatedBy
  createdBy
  createdAt
  status
}
fragment ProductionMaterialEventDetailFragment on ProductionMaterialEventDetailData {
  description
  materialItemId
  multiple
  productionMaterialEventDetailId
  triggerId
}`);
export const RemoveProductionMaterialEventDetailDocument = new TypedDocumentString(`
    mutation RemoveProductionMaterialEventDetail($input: RemoveProductionMaterialEventDetailInput!) {
  removeProductionMaterialEventDetail(input: $input) {
    event {
      ...ProductionMaterialEventDetails
    }
    errors {
      code
      message
    }
  }
}
    fragment ProductionMaterialEventDetails on ProductionMaterialEventStateData {
  tenantId
  productionMaterialEventId
  name
  details {
    ...ProductionMaterialEventDetailFragment
  }
  updatedAt
  updatedBy
  createdBy
  createdAt
  status
}
fragment ProductionMaterialEventDetailFragment on ProductionMaterialEventDetailData {
  description
  materialItemId
  multiple
  productionMaterialEventDetailId
  triggerId
}`);
export const CreateProductionTaskEventDocument = new TypedDocumentString(`
    mutation CreateProductionTaskEvent($input: CreateProductionTaskEventInput!) {
  createProductionTaskEvent(input: $input) {
    event {
      ...ProductionTaskEventDetails
    }
    errors {
      code
      message
    }
  }
}
    fragment ProductionTaskEventDetails on ProductionTaskEventStateData {
  tenantId
  productionTaskEventId
  name
  status
  unitsPerHour
  laborTypeTagId
  costPerEvent
  createdBy
  createdAt
  updatedBy
  updatedAt
  details {
    ...ProductionTaskEventDetailFragment
  }
}
fragment ProductionTaskEventDetailFragment on ProductionTaskEventDetailData {
  taskEventType {
    reducesSellableStock
  }
  description
  taskEventTypeId
  taskEventTypeName
  materialItemId
  multiple
  productionTaskEventDetailId
  sequence
  triggerId
  unitsPerHour
}`);
export const UpdateProductionTaskEventDocument = new TypedDocumentString(`
    mutation UpdateProductionTaskEvent($input: UpdateProductionTaskEventInput!) {
  updateProductionTaskEvent(input: $input) {
    event {
      ...ProductionTaskEventDetails
    }
    errors {
      code
      message
    }
  }
}
    fragment ProductionTaskEventDetails on ProductionTaskEventStateData {
  tenantId
  productionTaskEventId
  name
  status
  unitsPerHour
  laborTypeTagId
  costPerEvent
  createdBy
  createdAt
  updatedBy
  updatedAt
  details {
    ...ProductionTaskEventDetailFragment
  }
}
fragment ProductionTaskEventDetailFragment on ProductionTaskEventDetailData {
  taskEventType {
    reducesSellableStock
  }
  description
  taskEventTypeId
  taskEventTypeName
  materialItemId
  multiple
  productionTaskEventDetailId
  sequence
  triggerId
  unitsPerHour
}`);
export const ActivateProductionTaskEventDocument = new TypedDocumentString(`
    mutation ActivateProductionTaskEvent($input: ActivateProductionTaskEventInput!) {
  activateProductionTaskEvent(input: $input) {
    event {
      ...ProductionTaskEventDetails
    }
    errors {
      code
      message
    }
  }
}
    fragment ProductionTaskEventDetails on ProductionTaskEventStateData {
  tenantId
  productionTaskEventId
  name
  status
  unitsPerHour
  laborTypeTagId
  costPerEvent
  createdBy
  createdAt
  updatedBy
  updatedAt
  details {
    ...ProductionTaskEventDetailFragment
  }
}
fragment ProductionTaskEventDetailFragment on ProductionTaskEventDetailData {
  taskEventType {
    reducesSellableStock
  }
  description
  taskEventTypeId
  taskEventTypeName
  materialItemId
  multiple
  productionTaskEventDetailId
  sequence
  triggerId
  unitsPerHour
}`);
export const InactivateProductionTaskEventDocument = new TypedDocumentString(`
    mutation InactivateProductionTaskEvent($input: InactivateProductionTaskEventInput!) {
  inactivateProductionTaskEvent(input: $input) {
    event {
      ...ProductionTaskEventDetails
    }
    errors {
      code
      message
    }
  }
}
    fragment ProductionTaskEventDetails on ProductionTaskEventStateData {
  tenantId
  productionTaskEventId
  name
  status
  unitsPerHour
  laborTypeTagId
  costPerEvent
  createdBy
  createdAt
  updatedBy
  updatedAt
  details {
    ...ProductionTaskEventDetailFragment
  }
}
fragment ProductionTaskEventDetailFragment on ProductionTaskEventDetailData {
  taskEventType {
    reducesSellableStock
  }
  description
  taskEventTypeId
  taskEventTypeName
  materialItemId
  multiple
  productionTaskEventDetailId
  sequence
  triggerId
  unitsPerHour
}`);
export const DeleteProductionTaskEventDocument = new TypedDocumentString(`
    mutation DeleteProductionTaskEvent($input: DeleteProductionTaskEventInput!) {
  deleteProductionTaskEvent(input: $input) {
    event {
      ...ProductionTaskEventDetails
    }
    errors {
      code
      message
    }
  }
}
    fragment ProductionTaskEventDetails on ProductionTaskEventStateData {
  tenantId
  productionTaskEventId
  name
  status
  unitsPerHour
  laborTypeTagId
  costPerEvent
  createdBy
  createdAt
  updatedBy
  updatedAt
  details {
    ...ProductionTaskEventDetailFragment
  }
}
fragment ProductionTaskEventDetailFragment on ProductionTaskEventDetailData {
  taskEventType {
    reducesSellableStock
  }
  description
  taskEventTypeId
  taskEventTypeName
  materialItemId
  multiple
  productionTaskEventDetailId
  sequence
  triggerId
  unitsPerHour
}`);
export const AddProductionTaskEventDetailsDocument = new TypedDocumentString(`
    mutation AddProductionTaskEventDetails($input: AddProductionTaskEventDetailsInput!) {
  addProductionTaskEventDetails(input: $input) {
    event {
      ...ProductionTaskEventDetails
    }
    errors {
      code
      message
    }
  }
}
    fragment ProductionTaskEventDetails on ProductionTaskEventStateData {
  tenantId
  productionTaskEventId
  name
  status
  unitsPerHour
  laborTypeTagId
  costPerEvent
  createdBy
  createdAt
  updatedBy
  updatedAt
  details {
    ...ProductionTaskEventDetailFragment
  }
}
fragment ProductionTaskEventDetailFragment on ProductionTaskEventDetailData {
  taskEventType {
    reducesSellableStock
  }
  description
  taskEventTypeId
  taskEventTypeName
  materialItemId
  multiple
  productionTaskEventDetailId
  sequence
  triggerId
  unitsPerHour
}`);
export const UpdateProductionTaskEventDetailDocument = new TypedDocumentString(`
    mutation UpdateProductionTaskEventDetail($input: UpdateProductionTaskEventDetailInput!) {
  updateProductionTaskEventDetail(input: $input) {
    event {
      ...ProductionTaskEventDetails
    }
    errors {
      code
      message
    }
  }
}
    fragment ProductionTaskEventDetails on ProductionTaskEventStateData {
  tenantId
  productionTaskEventId
  name
  status
  unitsPerHour
  laborTypeTagId
  costPerEvent
  createdBy
  createdAt
  updatedBy
  updatedAt
  details {
    ...ProductionTaskEventDetailFragment
  }
}
fragment ProductionTaskEventDetailFragment on ProductionTaskEventDetailData {
  taskEventType {
    reducesSellableStock
  }
  description
  taskEventTypeId
  taskEventTypeName
  materialItemId
  multiple
  productionTaskEventDetailId
  sequence
  triggerId
  unitsPerHour
}`);
export const RemoveProductionTaskEventDetailDocument = new TypedDocumentString(`
    mutation RemoveProductionTaskEventDetail($input: RemoveProductionTaskEventDetailInput!) {
  removeProductionTaskEventDetail(input: $input) {
    event {
      ...ProductionTaskEventDetails
    }
    errors {
      code
      message
    }
  }
}
    fragment ProductionTaskEventDetails on ProductionTaskEventStateData {
  tenantId
  productionTaskEventId
  name
  status
  unitsPerHour
  laborTypeTagId
  costPerEvent
  createdBy
  createdAt
  updatedBy
  updatedAt
  details {
    ...ProductionTaskEventDetailFragment
  }
}
fragment ProductionTaskEventDetailFragment on ProductionTaskEventDetailData {
  taskEventType {
    reducesSellableStock
  }
  description
  taskEventTypeId
  taskEventTypeName
  materialItemId
  multiple
  productionTaskEventDetailId
  sequence
  triggerId
  unitsPerHour
}`);
export const SetTaskEventThroughputDocument = new TypedDocumentString(`
    mutation SetTaskEventThroughput($input: SetTaskEventThroughputInput!) {
  setTaskEventThroughput(input: $input) {
    event {
      ...ProductionTaskEventDetails
    }
    errors {
      code
      message
    }
  }
}
    fragment ProductionTaskEventDetails on ProductionTaskEventStateData {
  tenantId
  productionTaskEventId
  name
  status
  unitsPerHour
  laborTypeTagId
  costPerEvent
  createdBy
  createdAt
  updatedBy
  updatedAt
  details {
    ...ProductionTaskEventDetailFragment
  }
}
fragment ProductionTaskEventDetailFragment on ProductionTaskEventDetailData {
  taskEventType {
    reducesSellableStock
  }
  description
  taskEventTypeId
  taskEventTypeName
  materialItemId
  multiple
  productionTaskEventDetailId
  sequence
  triggerId
  unitsPerHour
}`);
export const SetTaskEventLaborTypeTagDocument = new TypedDocumentString(`
    mutation SetTaskEventLaborTypeTag($input: SetTaskEventLaborTypeTagInput!) {
  setTaskEventLaborTypeTag(input: $input) {
    event {
      ...ProductionTaskEventDetails
    }
    errors {
      code
      message
    }
  }
}
    fragment ProductionTaskEventDetails on ProductionTaskEventStateData {
  tenantId
  productionTaskEventId
  name
  status
  unitsPerHour
  laborTypeTagId
  costPerEvent
  createdBy
  createdAt
  updatedBy
  updatedAt
  details {
    ...ProductionTaskEventDetailFragment
  }
}
fragment ProductionTaskEventDetailFragment on ProductionTaskEventDetailData {
  taskEventType {
    reducesSellableStock
  }
  description
  taskEventTypeId
  taskEventTypeName
  materialItemId
  multiple
  productionTaskEventDetailId
  sequence
  triggerId
  unitsPerHour
}`);
export const CreateProductionSpaceEventDocument = new TypedDocumentString(`
    mutation CreateProductionSpaceEvent($input: CreateProductionSpaceEventInput!) {
  createProductionSpaceEvent(input: $input) {
    event {
      ...ProductionSpaceEventDetails
    }
    errors {
      code
      message
    }
  }
}
    fragment ProductionSpaceEventDetails on ProductionSpaceEventStateData {
  createdAt
  createdBy
  details {
    ...ProductionSpaceEventDetailFragment
  }
  name
  productionSpaceEventId
  status
  tenantId
  updatedAt
  updatedBy
}
fragment ProductionSpaceEventDetailFragment on ProductionSpaceEventDetailData {
  description
  duration
  productionSpaceCategoryId
  productionSpaceEventDetailId
  productionSpaceTypeId
  triggerId
}`);
export const UpdateProductionSpaceEventDocument = new TypedDocumentString(`
    mutation UpdateProductionSpaceEvent($input: UpdateProductionSpaceEventInput!) {
  updateProductionSpaceEvent(input: $input) {
    event {
      ...ProductionSpaceEventDetails
    }
    errors {
      code
      message
    }
  }
}
    fragment ProductionSpaceEventDetails on ProductionSpaceEventStateData {
  createdAt
  createdBy
  details {
    ...ProductionSpaceEventDetailFragment
  }
  name
  productionSpaceEventId
  status
  tenantId
  updatedAt
  updatedBy
}
fragment ProductionSpaceEventDetailFragment on ProductionSpaceEventDetailData {
  description
  duration
  productionSpaceCategoryId
  productionSpaceEventDetailId
  productionSpaceTypeId
  triggerId
}`);
export const ActivateProductionSpaceEventDocument = new TypedDocumentString(`
    mutation ActivateProductionSpaceEvent($input: ActivateProductionSpaceEventInput!) {
  activateProductionSpaceEvent(input: $input) {
    event {
      ...ProductionSpaceEventDetails
    }
    errors {
      code
      message
    }
  }
}
    fragment ProductionSpaceEventDetails on ProductionSpaceEventStateData {
  createdAt
  createdBy
  details {
    ...ProductionSpaceEventDetailFragment
  }
  name
  productionSpaceEventId
  status
  tenantId
  updatedAt
  updatedBy
}
fragment ProductionSpaceEventDetailFragment on ProductionSpaceEventDetailData {
  description
  duration
  productionSpaceCategoryId
  productionSpaceEventDetailId
  productionSpaceTypeId
  triggerId
}`);
export const InactivateProductionSpaceEventDocument = new TypedDocumentString(`
    mutation InactivateProductionSpaceEvent($input: InactivateProductionSpaceEventInput!) {
  inactivateProductionSpaceEvent(input: $input) {
    event {
      ...ProductionSpaceEventDetails
    }
    errors {
      code
      message
    }
  }
}
    fragment ProductionSpaceEventDetails on ProductionSpaceEventStateData {
  createdAt
  createdBy
  details {
    ...ProductionSpaceEventDetailFragment
  }
  name
  productionSpaceEventId
  status
  tenantId
  updatedAt
  updatedBy
}
fragment ProductionSpaceEventDetailFragment on ProductionSpaceEventDetailData {
  description
  duration
  productionSpaceCategoryId
  productionSpaceEventDetailId
  productionSpaceTypeId
  triggerId
}`);
export const DeleteProductionSpaceEventDocument = new TypedDocumentString(`
    mutation DeleteProductionSpaceEvent($input: DeleteProductionSpaceEventInput!) {
  deleteProductionSpaceEvent(input: $input) {
    event {
      ...ProductionSpaceEventDetails
    }
    errors {
      code
      message
    }
  }
}
    fragment ProductionSpaceEventDetails on ProductionSpaceEventStateData {
  createdAt
  createdBy
  details {
    ...ProductionSpaceEventDetailFragment
  }
  name
  productionSpaceEventId
  status
  tenantId
  updatedAt
  updatedBy
}
fragment ProductionSpaceEventDetailFragment on ProductionSpaceEventDetailData {
  description
  duration
  productionSpaceCategoryId
  productionSpaceEventDetailId
  productionSpaceTypeId
  triggerId
}`);
export const AddProductionSpaceEventDetailsDocument = new TypedDocumentString(`
    mutation AddProductionSpaceEventDetails($input: AddProductionSpaceEventDetailsInput!) {
  addProductionSpaceEventDetails(input: $input) {
    event {
      ...ProductionSpaceEventDetails
    }
    errors {
      code
      message
    }
  }
}
    fragment ProductionSpaceEventDetails on ProductionSpaceEventStateData {
  createdAt
  createdBy
  details {
    ...ProductionSpaceEventDetailFragment
  }
  name
  productionSpaceEventId
  status
  tenantId
  updatedAt
  updatedBy
}
fragment ProductionSpaceEventDetailFragment on ProductionSpaceEventDetailData {
  description
  duration
  productionSpaceCategoryId
  productionSpaceEventDetailId
  productionSpaceTypeId
  triggerId
}`);
export const UpdateProductionSpaceEventDetailDocument = new TypedDocumentString(`
    mutation UpdateProductionSpaceEventDetail($input: UpdateProductionSpaceEventDetailInput!) {
  updateProductionSpaceEventDetail(input: $input) {
    event {
      ...ProductionSpaceEventDetails
    }
    errors {
      code
      message
    }
  }
}
    fragment ProductionSpaceEventDetails on ProductionSpaceEventStateData {
  createdAt
  createdBy
  details {
    ...ProductionSpaceEventDetailFragment
  }
  name
  productionSpaceEventId
  status
  tenantId
  updatedAt
  updatedBy
}
fragment ProductionSpaceEventDetailFragment on ProductionSpaceEventDetailData {
  description
  duration
  productionSpaceCategoryId
  productionSpaceEventDetailId
  productionSpaceTypeId
  triggerId
}`);
export const RemoveProductionSpaceEventDetailDocument = new TypedDocumentString(`
    mutation RemoveProductionSpaceEventDetail($input: RemoveProductionSpaceEventDetailInput!) {
  removeProductionSpaceEventDetail(input: $input) {
    event {
      ...ProductionSpaceEventDetails
    }
    errors {
      code
      message
    }
  }
}
    fragment ProductionSpaceEventDetails on ProductionSpaceEventStateData {
  createdAt
  createdBy
  details {
    ...ProductionSpaceEventDetailFragment
  }
  name
  productionSpaceEventId
  status
  tenantId
  updatedAt
  updatedBy
}
fragment ProductionSpaceEventDetailFragment on ProductionSpaceEventDetailData {
  description
  duration
  productionSpaceCategoryId
  productionSpaceEventDetailId
  productionSpaceTypeId
  triggerId
}`);
export const ClearTaskEventThroughputDocument = new TypedDocumentString(`
    mutation ClearTaskEventThroughput($input: ClearTaskEventThroughputInput!) {
  clearTaskEventThroughput(input: $input) {
    event {
      ...ProductionTaskEventDetails
    }
    errors {
      code
      message
    }
  }
}
    fragment ProductionTaskEventDetails on ProductionTaskEventStateData {
  tenantId
  productionTaskEventId
  name
  status
  unitsPerHour
  laborTypeTagId
  costPerEvent
  createdBy
  createdAt
  updatedBy
  updatedAt
  details {
    ...ProductionTaskEventDetailFragment
  }
}
fragment ProductionTaskEventDetailFragment on ProductionTaskEventDetailData {
  taskEventType {
    reducesSellableStock
  }
  description
  taskEventTypeId
  taskEventTypeName
  materialItemId
  multiple
  productionTaskEventDetailId
  sequence
  triggerId
  unitsPerHour
}`);
export const ClearTaskEventLaborTypeTagDocument = new TypedDocumentString(`
    mutation ClearTaskEventLaborTypeTag($input: ClearTaskEventLaborTypeTagInput!) {
  clearTaskEventLaborTypeTag(input: $input) {
    event {
      ...ProductionTaskEventDetails
    }
    errors {
      code
      message
    }
  }
}
    fragment ProductionTaskEventDetails on ProductionTaskEventStateData {
  tenantId
  productionTaskEventId
  name
  status
  unitsPerHour
  laborTypeTagId
  costPerEvent
  createdBy
  createdAt
  updatedBy
  updatedAt
  details {
    ...ProductionTaskEventDetailFragment
  }
}
fragment ProductionTaskEventDetailFragment on ProductionTaskEventDetailData {
  taskEventType {
    reducesSellableStock
  }
  description
  taskEventTypeId
  taskEventTypeName
  materialItemId
  multiple
  productionTaskEventDetailId
  sequence
  triggerId
  unitsPerHour
}`);
export const SetTaskEventDetailThroughputDocument = new TypedDocumentString(`
    mutation SetTaskEventDetailThroughput($input: SetTaskEventDetailThroughputInput!) {
  setTaskEventDetailThroughput(input: $input) {
    event {
      ...ProductionTaskEventDetails
    }
    errors {
      code
      message
    }
  }
}
    fragment ProductionTaskEventDetails on ProductionTaskEventStateData {
  tenantId
  productionTaskEventId
  name
  status
  unitsPerHour
  laborTypeTagId
  costPerEvent
  createdBy
  createdAt
  updatedBy
  updatedAt
  details {
    ...ProductionTaskEventDetailFragment
  }
}
fragment ProductionTaskEventDetailFragment on ProductionTaskEventDetailData {
  taskEventType {
    reducesSellableStock
  }
  description
  taskEventTypeId
  taskEventTypeName
  materialItemId
  multiple
  productionTaskEventDetailId
  sequence
  triggerId
  unitsPerHour
}`);
export const SetTaskEventDirectCostDocument = new TypedDocumentString(`
    mutation SetTaskEventDirectCost($input: SetTaskEventDirectCostInput!) {
  setTaskEventDirectCost(input: $input) {
    event {
      ...ProductionTaskEventDetails
    }
    errors {
      code
      message
    }
  }
}
    fragment ProductionTaskEventDetails on ProductionTaskEventStateData {
  tenantId
  productionTaskEventId
  name
  status
  unitsPerHour
  laborTypeTagId
  costPerEvent
  createdBy
  createdAt
  updatedBy
  updatedAt
  details {
    ...ProductionTaskEventDetailFragment
  }
}
fragment ProductionTaskEventDetailFragment on ProductionTaskEventDetailData {
  taskEventType {
    reducesSellableStock
  }
  description
  taskEventTypeId
  taskEventTypeName
  materialItemId
  multiple
  productionTaskEventDetailId
  sequence
  triggerId
  unitsPerHour
}`);
export const ClearTaskEventDirectCostDocument = new TypedDocumentString(`
    mutation ClearTaskEventDirectCost($input: ClearTaskEventDirectCostInput!) {
  clearTaskEventDirectCost(input: $input) {
    event {
      ...ProductionTaskEventDetails
    }
    errors {
      code
      message
    }
  }
}
    fragment ProductionTaskEventDetails on ProductionTaskEventStateData {
  tenantId
  productionTaskEventId
  name
  status
  unitsPerHour
  laborTypeTagId
  costPerEvent
  createdBy
  createdAt
  updatedBy
  updatedAt
  details {
    ...ProductionTaskEventDetailFragment
  }
}
fragment ProductionTaskEventDetailFragment on ProductionTaskEventDetailData {
  taskEventType {
    reducesSellableStock
  }
  description
  taskEventTypeId
  taskEventTypeName
  materialItemId
  multiple
  productionTaskEventDetailId
  sequence
  triggerId
  unitsPerHour
}`);
const injectedRtkApiEndpoints = (build: GraphqlEndpointBuilder) => ({
    CreateProductionMaterialEvent: build.mutation<CreateProductionMaterialEventMutation, CreateProductionMaterialEventMutationVariables>({
      query: (variables) => ({ document: CreateProductionMaterialEventDocument, variables })
    }),
    UpdateProductionMaterialEvent: build.mutation<UpdateProductionMaterialEventMutation, UpdateProductionMaterialEventMutationVariables>({
      query: (variables) => ({ document: UpdateProductionMaterialEventDocument, variables })
    }),
    ActivateProductionMaterialEvent: build.mutation<ActivateProductionMaterialEventMutation, ActivateProductionMaterialEventMutationVariables>({
      query: (variables) => ({ document: ActivateProductionMaterialEventDocument, variables })
    }),
    InactivateProductionMaterialEvent: build.mutation<InactivateProductionMaterialEventMutation, InactivateProductionMaterialEventMutationVariables>({
      query: (variables) => ({ document: InactivateProductionMaterialEventDocument, variables })
    }),
    DeleteProductionMaterialEvent: build.mutation<DeleteProductionMaterialEventMutation, DeleteProductionMaterialEventMutationVariables>({
      query: (variables) => ({ document: DeleteProductionMaterialEventDocument, variables })
    }),
    AddProductionMaterialEventDetails: build.mutation<AddProductionMaterialEventDetailsMutation, AddProductionMaterialEventDetailsMutationVariables>({
      query: (variables) => ({ document: AddProductionMaterialEventDetailsDocument, variables })
    }),
    UpdateProductionMaterialEventDetail: build.mutation<UpdateProductionMaterialEventDetailMutation, UpdateProductionMaterialEventDetailMutationVariables>({
      query: (variables) => ({ document: UpdateProductionMaterialEventDetailDocument, variables })
    }),
    RemoveProductionMaterialEventDetail: build.mutation<RemoveProductionMaterialEventDetailMutation, RemoveProductionMaterialEventDetailMutationVariables>({
      query: (variables) => ({ document: RemoveProductionMaterialEventDetailDocument, variables })
    }),
    CreateProductionTaskEvent: build.mutation<CreateProductionTaskEventMutation, CreateProductionTaskEventMutationVariables>({
      query: (variables) => ({ document: CreateProductionTaskEventDocument, variables })
    }),
    UpdateProductionTaskEvent: build.mutation<UpdateProductionTaskEventMutation, UpdateProductionTaskEventMutationVariables>({
      query: (variables) => ({ document: UpdateProductionTaskEventDocument, variables })
    }),
    ActivateProductionTaskEvent: build.mutation<ActivateProductionTaskEventMutation, ActivateProductionTaskEventMutationVariables>({
      query: (variables) => ({ document: ActivateProductionTaskEventDocument, variables })
    }),
    InactivateProductionTaskEvent: build.mutation<InactivateProductionTaskEventMutation, InactivateProductionTaskEventMutationVariables>({
      query: (variables) => ({ document: InactivateProductionTaskEventDocument, variables })
    }),
    DeleteProductionTaskEvent: build.mutation<DeleteProductionTaskEventMutation, DeleteProductionTaskEventMutationVariables>({
      query: (variables) => ({ document: DeleteProductionTaskEventDocument, variables })
    }),
    AddProductionTaskEventDetails: build.mutation<AddProductionTaskEventDetailsMutation, AddProductionTaskEventDetailsMutationVariables>({
      query: (variables) => ({ document: AddProductionTaskEventDetailsDocument, variables })
    }),
    UpdateProductionTaskEventDetail: build.mutation<UpdateProductionTaskEventDetailMutation, UpdateProductionTaskEventDetailMutationVariables>({
      query: (variables) => ({ document: UpdateProductionTaskEventDetailDocument, variables })
    }),
    RemoveProductionTaskEventDetail: build.mutation<RemoveProductionTaskEventDetailMutation, RemoveProductionTaskEventDetailMutationVariables>({
      query: (variables) => ({ document: RemoveProductionTaskEventDetailDocument, variables })
    }),
    SetTaskEventThroughput: build.mutation<SetTaskEventThroughputMutation, SetTaskEventThroughputMutationVariables>({
      query: (variables) => ({ document: SetTaskEventThroughputDocument, variables })
    }),
    SetTaskEventLaborTypeTag: build.mutation<SetTaskEventLaborTypeTagMutation, SetTaskEventLaborTypeTagMutationVariables>({
      query: (variables) => ({ document: SetTaskEventLaborTypeTagDocument, variables })
    }),
    CreateProductionSpaceEvent: build.mutation<CreateProductionSpaceEventMutation, CreateProductionSpaceEventMutationVariables>({
      query: (variables) => ({ document: CreateProductionSpaceEventDocument, variables })
    }),
    UpdateProductionSpaceEvent: build.mutation<UpdateProductionSpaceEventMutation, UpdateProductionSpaceEventMutationVariables>({
      query: (variables) => ({ document: UpdateProductionSpaceEventDocument, variables })
    }),
    ActivateProductionSpaceEvent: build.mutation<ActivateProductionSpaceEventMutation, ActivateProductionSpaceEventMutationVariables>({
      query: (variables) => ({ document: ActivateProductionSpaceEventDocument, variables })
    }),
    InactivateProductionSpaceEvent: build.mutation<InactivateProductionSpaceEventMutation, InactivateProductionSpaceEventMutationVariables>({
      query: (variables) => ({ document: InactivateProductionSpaceEventDocument, variables })
    }),
    DeleteProductionSpaceEvent: build.mutation<DeleteProductionSpaceEventMutation, DeleteProductionSpaceEventMutationVariables>({
      query: (variables) => ({ document: DeleteProductionSpaceEventDocument, variables })
    }),
    AddProductionSpaceEventDetails: build.mutation<AddProductionSpaceEventDetailsMutation, AddProductionSpaceEventDetailsMutationVariables>({
      query: (variables) => ({ document: AddProductionSpaceEventDetailsDocument, variables })
    }),
    UpdateProductionSpaceEventDetail: build.mutation<UpdateProductionSpaceEventDetailMutation, UpdateProductionSpaceEventDetailMutationVariables>({
      query: (variables) => ({ document: UpdateProductionSpaceEventDetailDocument, variables })
    }),
    RemoveProductionSpaceEventDetail: build.mutation<RemoveProductionSpaceEventDetailMutation, RemoveProductionSpaceEventDetailMutationVariables>({
      query: (variables) => ({ document: RemoveProductionSpaceEventDetailDocument, variables })
    }),
    ClearTaskEventThroughput: build.mutation<ClearTaskEventThroughputMutation, ClearTaskEventThroughputMutationVariables>({
      query: (variables) => ({ document: ClearTaskEventThroughputDocument, variables })
    }),
    ClearTaskEventLaborTypeTag: build.mutation<ClearTaskEventLaborTypeTagMutation, ClearTaskEventLaborTypeTagMutationVariables>({
      query: (variables) => ({ document: ClearTaskEventLaborTypeTagDocument, variables })
    }),
    SetTaskEventDetailThroughput: build.mutation<SetTaskEventDetailThroughputMutation, SetTaskEventDetailThroughputMutationVariables>({
      query: (variables) => ({ document: SetTaskEventDetailThroughputDocument, variables })
    }),
    SetTaskEventDirectCost: build.mutation<SetTaskEventDirectCostMutation, SetTaskEventDirectCostMutationVariables>({
      query: (variables) => ({ document: SetTaskEventDirectCostDocument, variables })
    }),
    ClearTaskEventDirectCost: build.mutation<ClearTaskEventDirectCostMutation, ClearTaskEventDirectCostMutationVariables>({
      query: (variables) => ({ document: ClearTaskEventDirectCostDocument, variables })
    }),
});

const injectedRtkApi = baseApiWithGraphql.injectEndpoints({ endpoints: injectedRtkApiEndpoints });

export type GeneratedEndpointDefinitions = ReturnType<typeof injectedRtkApiEndpoints>;

export { injectedRtkApi as api };
export const { useCreateProductionMaterialEventMutation, useUpdateProductionMaterialEventMutation, useActivateProductionMaterialEventMutation, useInactivateProductionMaterialEventMutation, useDeleteProductionMaterialEventMutation, useAddProductionMaterialEventDetailsMutation, useUpdateProductionMaterialEventDetailMutation, useRemoveProductionMaterialEventDetailMutation, useCreateProductionTaskEventMutation, useUpdateProductionTaskEventMutation, useActivateProductionTaskEventMutation, useInactivateProductionTaskEventMutation, useDeleteProductionTaskEventMutation, useAddProductionTaskEventDetailsMutation, useUpdateProductionTaskEventDetailMutation, useRemoveProductionTaskEventDetailMutation, useSetTaskEventThroughputMutation, useSetTaskEventLaborTypeTagMutation, useCreateProductionSpaceEventMutation, useUpdateProductionSpaceEventMutation, useActivateProductionSpaceEventMutation, useInactivateProductionSpaceEventMutation, useDeleteProductionSpaceEventMutation, useAddProductionSpaceEventDetailsMutation, useUpdateProductionSpaceEventDetailMutation, useRemoveProductionSpaceEventDetailMutation, useClearTaskEventThroughputMutation, useClearTaskEventLaborTypeTagMutation, useSetTaskEventDetailThroughputMutation, useSetTaskEventDirectCostMutation, useClearTaskEventDirectCostMutation } = injectedRtkApi;
